import { ReactElement, PropsWithChildren } from "react";

import styles from "./footerButtons.module.css";

const FooterButtons = ({ children }: PropsWithChildren): ReactElement => {
  return <div className={styles.buttonContainer}>{children}</div>;
};

export default FooterButtons;
